import FooterOne from "../footer/FooterOne";
import HeaderOne from "../header/HeaderOne";
import BlogSidebar from '../components/BlogSidebar';
import Breadcrumb from "../components/BreadCurmb";
import { Link } from "react-router-dom"
import CommentFrom from "../components/CommentForm";
export default function NewsDetails(){
	return(
		<>
			<HeaderOne />
			<Breadcrumb title="Single Post" subtitle="Responsive & functional IT blog" pagetitle="News Details" />
		
				<section class="news-feed-area pt-120 pb-75 pt-md-60 pb-md-15 pt-xs-60 pb-xs-15">
					<div class="container">
						<div class="row mb-15">
							<div class="col-lg-8 pe-xl-0">
								<div class="news-details-left mb-30">
									<div class="blogs__meta mb-15">
										<span><i class="fal fa-eye"></i> 100 Views</span>
										<span class="border-line2"><i class="fal fa-comments"></i> 30 Comments</span>
										<span><i class="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
									<p class="mb-55">A great commerce experience cannot be distilled to a single number. It’s
										not a Lighthouse score, or a set of Core Web Vitals figures, although both are important
										inputs. A great commerce experience is a trilemma that carefully balances competing
										needs of delivering great customer experience, dynamic storefront capabilities, and
										long-term business — conversion, retention, re-engagement — objectives. As developers,
										we rightfully obsess about the customer experience, relentlessly working to squeeze
										every millisecond out of the critical rendering path, optimize input latency, and
										eliminate jank. At the limit, statically generated, edge delivered, and HTML-first pages
										look like the optimal strategy. That is until you are confronted with the realization
										that the next step function in improving conversion rates and business.
									</p>
									<img class="img-fluid" src="assets/img/blog/blog-14.jpg" alt="Blog Img" />
									<h3 class="mt-55 mb-25"><a class="s-sub-title" href="news-details.html">A cleansing hot
											shower or bath</a>
									</h3>
									<p>The journey, often, starts “simple” with localization. But then, quickly advances to
										contextual pricing, juggling complexity of large and frequently updated product catalog,
										managing continuously running multivariate tests and promotion campaigns, and serving
										customer-tailored dynamic recommendations. Eventually, you reach a realization that
										every page is similar to an open Tetris board where each “slot” can and should be
										dynamically tailored by dynamic visitor preferences, all powered by an ever-growing set
										of dynamic business rules.
									</p>
									<h3 class="mt-50 mb-20"><a class="s-sub-title" href="news-details.html">Setting the mood
											with incense</a></h3>
									<div class="news-boxes mb-25">
										<img class="box-img" src="assets/img/blog/blog-15.jpg" alt="Img" />
										<p class="overflow-hidden">From connecting back-office operations to front-of-the-house
											A/B testing and dynamic personalization for each customer, the shared foundation is
											fast
											server-side rendering powered by fast storefront data access. On top of this
											foundation, we add layers of caching, prerendering and edge delivery
											optimizations — not the other way around.</p>
									</div>
									<blockquote class="blog-block text-center">
										<div class="icon"><i class="fas fa-quote-left"></i></div>
										<h3 class="mb-30">Choices to take a holiday and travelling
											out inthis pandemic situation are limited. Why not take a stay action on quality.
										</h3>
										<h5 class="fs-20">Rosalina D. William </h5>
										<p class="fs-14 fw-bold text-theme2">Founder</p>
									</blockquote>
									<p>Surveying the existing landscape of available developer tools and runtimes, we felt that
										there is a gap. Enabling dynamic commerce requires close integration between server and
										client, an optimized streaming and data fetch strategy, and a production platform that
										operates at scale. These are hard technical problems that Shopify can help solve and
										this is why we’ve been hard at work on the Hydrogen framework. It’s a React-based
										framework optimized for commerce and specialized to be powered by Shopify APIs and
										infrastructure: The future of commerce is dynamic and personalized.</p>
									<div class="row share-social px-0 mt-55 pb-15">
										<div class="col-lg-6 col-md-6 mb-30">
											<h5 class="fs-20 mb-20">Releted Tags</h5>
											<div class="tag-list">
												<Link to="#">Popular</Link>
												<Link to="#">Design</Link>
												<Link to="#">UX</Link>
											</div>
										</div>
										<div class="col-lg-6 col-md-6 text-start text-md-end mb-30">
											<h5 class="fs-20 mb-20">Social Share</h5>
											<div class="author__social">
												<Link to="#"><i class="fab fa-facebook-f"></i></Link>
												<Link to="#"><i class="fab fa-twitter"></i></Link>
												<Link to="#"><i class="fab fa-behance"></i></Link>
												<Link to="#"><i class="fab fa-linkedin-in"></i></Link>
												<Link to="#"><i class="fab fa-google-plus-g"></i></Link>
											</div>
										</div>
									</div>
									<div class="row more-post align-items-center px-0">
										<div class="col-lg-5 col-md-5 mb-20">
											<div class="prev-box">
												<div class="prev-content">
													<p class="fs-14">Prev Post</p>
													<h3>Tips On Minimalist</h3>
												</div>
											</div>
										</div>
										<div class="col-lg-2 col-md-2 mb-20 text-start text-md-center">
											<img src="assets/img/icon/eclips-big2.png" alt="Icon" />
										</div>
										<div class="col-lg-5 col-md-5 mb-20">
											<div class="prev-box">
												<div class="prev-content text-start text-md-end">
													<p class="fs-14">Next Post</p>
													<h3>Less Is More</h3>
												</div>
											</div>
										</div>
									</div>
									<div class="authors-desc mt-60 mb-50">
										<div class="author-img">
											<img src="assets/img/blog/blog-author2.jpg" alt="Img" />
										</div>
										<div class="author-content">
											<p class="fs-12 lh-1 mb-1">Written by</p>
											<h3>Rosalina D. William</h3>
											<p class="fs-14">Getting fast initial render with streaming server-side rendering,
												efficient
												component-level updates and state transitions, while also setting up a
												performant loading and bundling strategy.</p>
										</div>
									</div>
									<div class="comments-wrapper">
										<h3 class="post-title mb-50">03 Comments</h3>
										<ul class="comment-list list-none">
											<li>
												<div class="comment-box">
													<div class="comment-avatar">
														<img src="assets/img/blog/comment-2.jpg" alt="Img" />
													</div>
													<div class="comment-content">
														<h5>Rosalina Kelian <Link to="#" class="reply"><i
																	class="fal fa-reply"></i> Reply</Link></h5>
														<p class="fs-14 mb-15"><i class="far fa-calendar-alt"></i> 24th March
															2022</p>
														<p>For all the assets is hard and time-consuming technical work. And, of
															course, the result needs to be seamless and delightful — dare we
															say, even fun — to develop and maintain. Regardless of whether
															you’re ing up a storefront for a new merchant.</p>
													</div>
												</div>
											</li>
											<li class="ml-130 ml-lg-30 ml-md-30 ml-xs-0">
												<div class="comment-box">
													<div class="comment-avatar">
														<img src="assets/img/blog/comment-3.jpg" alt="Img" />
													</div>
													<div class="comment-content">
														<h5>Rosalina Kelian <Link to="#" class="reply"><i
																	class="fal fa-reply"></i> Reply</Link></h5>
														<p class="fs-14 mb-15"><i class="far fa-calendar-alt"></i> 24th March
															2022</p>
														<p>Building a customer experience that will be visited by milBuilding a
															customer experience that will be visited by millions, the goal for
															Hydrogen is to eliminate undifferentiated and gnarly technical
															plumbing and enable you to start fast and focus on delivering
															merchant value.</p>
													</div>
												</div>
											</li>
											<li>
												<div class="comment-box">
													<div class="comment-avatar">
														<img src="assets/img/blog/comment-4.jpg" alt="Img" />
													</div>
													<div class="comment-content">
														<h5>Rosalina Kelian <Link to="#" class="reply"><i
																	class="fal fa-reply"></i>
																Reply</Link></h5>
														<p class="fs-14 mb-15"><i class="far fa-calendar-alt"></i> 24th March
															2022</p>
														<p>Unlocking such features and making them all work nicely together
															required that we work hands-on with React core team on helping
															define and prototype server components; Vite ecosystem on
															server-side streaming; Google’s Aurora team on integrating
															conformance.</p>
													</div>
												</div>
											</li>
										</ul>
									</div>
									<CommentFrom/>
								</div>
							</div>
							<div class="col-lg-4 pl-30 pl-lg-15 pl-md-15 pl-xs-15">
							<BlogSidebar />
							</div>
						</div>
					</div>
				</section>
		
			<FooterOne />	
		</>
	)
}
